const devPerfEnabled = () =>
  !!import.meta.env.QUASAR_DEV || !!import.meta.env.QUASAR_DEBUG

/**
 * Lightweight performance marks for local/dev profiling (Phase 0 baseline).
 */
export function perfMark (name) {
  if (!devPerfEnabled() || typeof performance?.mark !== 'function') return
  try {
    performance.mark(name)
  } catch {
    // ignore
  }
}

export function perfMeasure (name, startMark, endMark) {
  if (!devPerfEnabled() || typeof performance?.measure !== 'function') return null
  try {
    performance.measure(name, startMark, endMark)
    const entries = performance.getEntriesByName(name, 'measure')
    return entries[entries.length - 1]?.duration ?? null
  } catch {
    return null
  }
}

export function perfLogMeasure (label, startMark, endMark) {
  const duration = perfMeasure(label, startMark, endMark)
  if (duration != null) {
    console.debug(`[perf] ${label}: ${duration.toFixed(1)}ms`)
  }
}
